// EuroInstructionModal
import React from "react";
import {Modal} from "react-bootstrap";
import EuroInstructions from "./EuroInstructions";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faTimes} from '@fortawesome/free-solid-svg-icons';

const EuroInstructionModal = (props) => {
    const {
        isMobile,
        showModal,
        setShowModal,

    } = props;


    const render = () => {
        return (
            <>
                <Modal
                    show={showModal}
                    size="lg"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    onHide={() => {
                        setShowModal(false)
                    }}
                    scrollable={true}
                >
                    {/*<Modal.Header closeButton className={"border-0 text-skins-red"}>*/}
                    {/*    /!*<Modal.Title>Modal title</Modal.Title>*!/*/}
                    {/*</Modal.Header>*/}
                    <Modal.Body
                        // className={'text-center'}
                        // style={{marginTop:"-5%"}}
                        // style={{backgroundColor: '#1D1A3B'}}
                    >
                        <div className={"d-flex flex-column"}>
                            <div className={"d-flex justify-content-end align-items-end w-100"}>
                                <div className={"w-auto"} role={"button"} onClick={() => {
                                    setShowModal(false)
                                }}>
                                    <FontAwesomeIcon icon={faTimes}/>
                                </div>
                            </div>
                            <div className={"text-center"}>

                                <EuroInstructions
                                    isMobile={isMobile}
                                />
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
            </>
        );
    }

    return render();
}

export default EuroInstructionModal;
